var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._b({staticClass:"form-base__title preview break"},'div',_vm.$attrs,false),[_vm._v(" "+_vm._s(_vm.isApplicant ? _vm.labelApplicant : _vm.createDataField({ fieldName: _vm.fieldName, fieldGroup: _vm.fieldGroup }) .fieldLabel)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }